<!-- heading section -->
<div class="flex">
  <div class="flex-1">
    <h1 class="text-3xl font-semibold text-purple-400">Select Payment Details</h1>
    <p class="text-lg text-gray-600">
      <!-- todo: add sub heading/caption -->
      <span class="font-bold"></span>
    </p>
  </div>
  <div class="flex">
    <button
      pButton
      class=""
      icon="pi pi-times"
      class="p-button-rounded p-button-danger mt-2 p-button-text"
      (click)="closeDialog()"
    ></button>
  </div>
</div>

<share-form
  #pdf
  [formFields]="payFormFields"
  [formSubmitAction]="{
    label: 'Pay',
    icon: 'pi pi-user',
    styleClass: 'p-button-rounded p-button-info p-button-lg bg-blue-500 p-3 hover:bg-blue-300',
    enabled: true
  }"
  (formSubmitted)="onPaymentLinkSubmit($event)"
></share-form>
